import * as Types from '../../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GetAllLogisticsDeliveryStopsQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.DeliveryStopDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.DeliveryStopDocumentSortInput> | Types.DeliveryStopDocumentSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetAllLogisticsDeliveryStopsQuery = { __typename?: 'Query', logisticsDeliveryStops?: { __typename?: 'LogisticsDeliveryStopsConnection', totalCount: number, nodes?: Array<{ __typename?: 'DeliveryStopDocument', id: string, tenantId: string, loadId: string, routeStopId: string, customerLocationId?: string | null, customerName: string, outcome: Types.DeliveryOutcome, occurredAt?: Types.TDateISO | null, note?: string | null, recordedBy: string }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetAllLogisticsDeliveryOrderPortionsQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.DeliveryOrderPortionDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.DeliveryOrderPortionDocumentSortInput> | Types.DeliveryOrderPortionDocumentSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetAllLogisticsDeliveryOrderPortionsQuery = { __typename?: 'Query', logisticsDeliveryOrderPortions?: { __typename?: 'LogisticsDeliveryOrderPortionsConnection', totalCount: number, nodes?: Array<{ __typename?: 'DeliveryOrderPortionDocument', id: string, tenantId: string, loadLineId: string, loadId: string, orderId: string, orderNumber: string, routeStopId?: string | null, plannedContainerCount?: number | null, deliveredQuantity: number, refusedQuantity: number, outcome: Types.DeliveryOutcome, occurredAt?: Types.TDateISO | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetAllLogisticsDeliverySummariesQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.DeliverySummaryDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.DeliverySummaryDocumentSortInput> | Types.DeliverySummaryDocumentSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetAllLogisticsDeliverySummariesQuery = { __typename?: 'Query', logisticsDeliverySummaries?: { __typename?: 'LogisticsDeliverySummariesConnection', totalCount: number, nodes?: Array<{ __typename?: 'DeliverySummaryDocument', id: string, tenantId: string, loadId: string, status: Types.LoadStatus, dispatchedAt?: Types.TDateISO | null, completedAt?: Types.TDateISO | null, stopsTotal: number, stopsDelivered: number, stopsRefused: number, stopsPartial: number, stopsPending: number }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type LogisticsDeliveryStopDocumentFieldsFragment = { __typename?: 'DeliveryStopDocument', id: string, tenantId: string, loadId: string, routeStopId: string, customerLocationId?: string | null, customerName: string, outcome: Types.DeliveryOutcome, occurredAt?: Types.TDateISO | null, note?: string | null, recordedBy: string };

export type LogisticsDeliveryOrderPortionDocumentFieldsFragment = { __typename?: 'DeliveryOrderPortionDocument', id: string, tenantId: string, loadLineId: string, loadId: string, orderId: string, orderNumber: string, routeStopId?: string | null, plannedContainerCount?: number | null, deliveredQuantity: number, refusedQuantity: number, outcome: Types.DeliveryOutcome, occurredAt?: Types.TDateISO | null };

export type LogisticsDeliverySummaryDocumentFieldsFragment = { __typename?: 'DeliverySummaryDocument', id: string, tenantId: string, loadId: string, status: Types.LoadStatus, dispatchedAt?: Types.TDateISO | null, completedAt?: Types.TDateISO | null, stopsTotal: number, stopsDelivered: number, stopsRefused: number, stopsPartial: number, stopsPending: number };

export const LogisticsDeliveryStopDocumentFieldsFragmentDoc = new TypedDocumentString(`
    fragment LogisticsDeliveryStopDocumentFields on DeliveryStopDocument {
  id
  tenantId
  loadId
  routeStopId
  customerLocationId
  customerName
  outcome
  occurredAt
  note
  recordedBy
}
    `, {"fragmentName":"LogisticsDeliveryStopDocumentFields"});
export const LogisticsDeliveryOrderPortionDocumentFieldsFragmentDoc = new TypedDocumentString(`
    fragment LogisticsDeliveryOrderPortionDocumentFields on DeliveryOrderPortionDocument {
  id
  tenantId
  loadLineId
  loadId
  orderId
  orderNumber
  routeStopId
  plannedContainerCount
  deliveredQuantity
  refusedQuantity
  outcome
  occurredAt
}
    `, {"fragmentName":"LogisticsDeliveryOrderPortionDocumentFields"});
export const LogisticsDeliverySummaryDocumentFieldsFragmentDoc = new TypedDocumentString(`
    fragment LogisticsDeliverySummaryDocumentFields on DeliverySummaryDocument {
  id
  tenantId
  loadId
  status
  dispatchedAt
  completedAt
  stopsTotal
  stopsDelivered
  stopsRefused
  stopsPartial
  stopsPending
}
    `, {"fragmentName":"LogisticsDeliverySummaryDocumentFields"});
export const GetAllLogisticsDeliveryStopsDocument = new TypedDocumentString(`
    query GetAllLogisticsDeliveryStops($where: DeliveryStopDocumentFilterInput, $order: [DeliveryStopDocumentSortInput!], $first: Int, $after: String, $last: Int, $before: String) {
  logisticsDeliveryStops(
    where: $where
    order: $order
    first: $first
    last: $last
    before: $before
    after: $after
  ) {
    nodes {
      ...LogisticsDeliveryStopDocumentFields
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment LogisticsDeliveryStopDocumentFields on DeliveryStopDocument {
  id
  tenantId
  loadId
  routeStopId
  customerLocationId
  customerName
  outcome
  occurredAt
  note
  recordedBy
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetAllLogisticsDeliveryOrderPortionsDocument = new TypedDocumentString(`
    query GetAllLogisticsDeliveryOrderPortions($where: DeliveryOrderPortionDocumentFilterInput, $order: [DeliveryOrderPortionDocumentSortInput!], $first: Int, $after: String, $last: Int, $before: String) {
  logisticsDeliveryOrderPortions(
    where: $where
    order: $order
    first: $first
    last: $last
    before: $before
    after: $after
  ) {
    nodes {
      ...LogisticsDeliveryOrderPortionDocumentFields
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment LogisticsDeliveryOrderPortionDocumentFields on DeliveryOrderPortionDocument {
  id
  tenantId
  loadLineId
  loadId
  orderId
  orderNumber
  routeStopId
  plannedContainerCount
  deliveredQuantity
  refusedQuantity
  outcome
  occurredAt
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetAllLogisticsDeliverySummariesDocument = new TypedDocumentString(`
    query GetAllLogisticsDeliverySummaries($where: DeliverySummaryDocumentFilterInput, $order: [DeliverySummaryDocumentSortInput!], $first: Int, $after: String, $last: Int, $before: String) {
  logisticsDeliverySummaries(
    where: $where
    order: $order
    first: $first
    last: $last
    before: $before
    after: $after
  ) {
    nodes {
      ...LogisticsDeliverySummaryDocumentFields
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment LogisticsDeliverySummaryDocumentFields on DeliverySummaryDocument {
  id
  tenantId
  loadId
  status
  dispatchedAt
  completedAt
  stopsTotal
  stopsDelivered
  stopsRefused
  stopsPartial
  stopsPending
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetAllLogisticsDeliveryStops: build.query<GetAllLogisticsDeliveryStopsQuery, GetAllLogisticsDeliveryStopsQueryVariables | void>({
      query: (variables) => ({ document: GetAllLogisticsDeliveryStopsDocument, variables })
    }),
    GetAllLogisticsDeliveryOrderPortions: build.query<GetAllLogisticsDeliveryOrderPortionsQuery, GetAllLogisticsDeliveryOrderPortionsQueryVariables | void>({
      query: (variables) => ({ document: GetAllLogisticsDeliveryOrderPortionsDocument, variables })
    }),
    GetAllLogisticsDeliverySummaries: build.query<GetAllLogisticsDeliverySummariesQuery, GetAllLogisticsDeliverySummariesQueryVariables | void>({
      query: (variables) => ({ document: GetAllLogisticsDeliverySummariesDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetAllLogisticsDeliveryStopsQuery, useLazyGetAllLogisticsDeliveryStopsQuery, useGetAllLogisticsDeliveryOrderPortionsQuery, useLazyGetAllLogisticsDeliveryOrderPortionsQuery, useGetAllLogisticsDeliverySummariesQuery, useLazyGetAllLogisticsDeliverySummariesQuery } = injectedRtkApi;
